import React, { useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { Box, Typography, Button } from "@mui/material";
import bgBlock from "../assets/tamales-salinas/bg.jpg";

const containerStyle = {
  width: "100%",
  height: "100%",
  minHeight: "400px",
  borderRadius: "8px",
};

// Global styles to override Google Maps default InfoWindow padding and close button
const globalMapStyles = `
  /* Remove all padding and set border radius for the main InfoWindow container */
  .gm-style-iw {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  
  /* Target the exact internal container Google uses to wrap content */
  .gm-style-iw-c {
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  
  /* Target the content wrapper inside the InfoWindow */
  .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
    margin: 0 !important;
    border-radius: 12px !important;
    /* Ensure no scrollbars */
    max-height: none !important;
  }
  
  /* Remove any nested padding/margin that might be pushing the image down */
  .gm-style .gm-style-iw-c .gm-style-iw-d {
    overflow: hidden !important;
    padding: 0 !important;
  }
  
  .gm-style-iw-d > div {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Force the close button wrapper to absolute positioning so it doesn't affect document flow */
  button.gm-ui-hover-effect {
    position: absolute !important;
    top: 6px !important;
    right: 6px !important;
    background-color: rgba(0, 0, 0, 0.4) !important;
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    z-index: 10 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
  }
  
  /* Style the actual X icon inside the close button */
  button.gm-ui-hover-effect span {
    width: 14px !important;
    height: 14px !important;
    margin: 5px !important;
    background-color: white !important;
  }
  
  /* Hide the default white background block for the close button if Google injects it */
  .gm-style-iw-tc::after {
    /* Keeps the little pointer arrow pointing to the pin */
  }
`;

// Center map on Monterrey
const center = {
  lat: 25.6866,
  lng: -100.3161,
};

export const salinasStores = [
  // Monterrey
  { id: 1, name: "Centro", municipality: "Monterrey", address: "Zaragoza 725 Nte. entre Treviño y Carlos Salazar, Col. Centro", phone: "8372-5357 y 8372-1660", hasAutoTamal: true, lat: 25.6791, lng: -100.3113 },
  { id: 2, name: "Cumbres", municipality: "Monterrey", address: "Paseo de los Insurgentes 437, Cumbres 2do Sector", phone: "8348-3101 y 8333-8163", hasAutoTamal: false, lat: 25.7198, lng: -100.3643 },
  { id: 3, name: "Lagos del Bosque", municipality: "Monterrey", address: "Lago Erie #5103, Col. Lago del Bosque", phone: "8349-4853", hasAutoTamal: false, lat: 25.5996, lng: -100.2673 },
  { id: 4, name: "Simón Bolívar", municipality: "Monterrey", address: "Simón Bolívar #1776 Nte., Mitras Centro", phone: "8347-6888", hasAutoTamal: false, lat: 25.6946, lng: -100.3444 },
  { id: 5, name: "Lincoln", municipality: "Monterrey", address: "Av. Lincoln 5252, Col. Ampliación San Jorge (Exterior HEB Lincoln)", phone: "1365-1148 y 8372-1660", hasAutoTamal: false, lat: 25.7289, lng: -100.3552 },
  { id: 6, name: "Multiplaza Lincoln", municipality: "Monterrey", address: "Barrio de Chapultepec Sur (Interior HEB Lincoln)", phone: "8388-7879", hasAutoTamal: false, lat: 25.7538, lng: -100.3809 },
  { id: 7, name: "Plaza Real", municipality: "Monterrey", address: "Av. Gonzalitos 31, Local A10 (Exterior HEB Plaza Real)", phone: "8348-5855", hasAutoTamal: false, lat: 25.6821, lng: -100.3482 },
  { id: 8, name: "Puerta de Hierro", municipality: "Monterrey", address: "HEB Puerta de Hierro Local 18E, Col. Puerta de Hierro", phone: "8348-3101 y 8333-8163", hasAutoTamal: false, lat: 25.7410, lng: -100.3951 },
  { id: 9, name: "Contry", municipality: "Monterrey", address: "J. Cantú Leal #900, Col. Buenos Aires", phone: "8387-8386", hasAutoTamal: true, lat: 25.6482, lng: -100.2831 },
  
  // Guadalupe
  { id: 10, name: "Chapultepec", municipality: "Guadalupe", address: "HEB Chapultepec, Local 1 E. Av. Chapultepec #180, Paraíso", phone: "1970-7584", hasAutoTamal: true, lat: 25.6625, lng: -100.2709 },
  { id: 11, name: "Guadalupe", municipality: "Guadalupe", address: "Pablo Livas y Ave. México", phone: "8393-5001", hasAutoTamal: false, lat: 25.6669, lng: -100.2223 },
  { id: 12, name: "HEB Acapulco", municipality: "Guadalupe", address: "Av. Acapulco No. 161 Local 14-1, Fracc. Los Cristales", phone: "8240-9280", hasAutoTamal: false, lat: 25.7121, lng: -100.2079 },
  { id: 13, name: "Linda Vista", municipality: "Guadalupe", address: "Barcelona cruz con Astorga, Col. Valles de Linda Vista (a una cuadra de Miguel Alemán)", phone: "8394-3232", hasAutoTamal: true, lat: 25.6967, lng: -100.2520 },
  { id: 14, name: "Multiplaza Lindavista", municipality: "Guadalupe", address: "Av. Miguel Alemán 67130, Col. Linda Vista", phone: "8394-3662", hasAutoTamal: false, lat: 25.7005, lng: -100.2452 },
  { id: 15, name: "Tolteca", municipality: "Guadalupe", address: "HEB Guadalupe Juárez, Av. Benito Juárez #1051, cruz con Av. Lázaro Cárdenas", phone: "1970-7599", hasAutoTamal: false, lat: 25.6793, lng: -100.2428 },

  // Escobedo
  { id: 16, name: "Plaza Bella Anáhuac", municipality: "Escobedo", address: "Av. Sendero Norte y República Mexicana (Interior HEB Sendero)", phone: "8661-3040", hasAutoTamal: false, lat: 25.7628, lng: -100.2921 },
  { id: 17, name: "HEB Escobedo", municipality: "Escobedo", address: "Av. Raúl Salinas Lozano No. 297 L-15 (Interior HEB), Col. Los Girasoles", phone: "8397-9061", hasAutoTamal: false, lat: 25.7876, lng: -100.2974 },

  // San Nicolás de los Garza
  { id: 18, name: "Las Puentes", municipality: "San Nicolás de los Garza", address: "Cordillera de los Andes #610 Pte., Col. Residencial Las Puentes", phone: "8350-7553", hasAutoTamal: false, lat: 25.7337, lng: -100.2828 },
  { id: 19, name: "Anáhuac", municipality: "San Nicolás de los Garza", address: "Av. Manuel L. Barragán #6967 entre Av. Topo Chico y Eduardo Marquina", phone: "8376-7194", hasAutoTamal: false, lat: 25.7408, lng: -100.3060 },
  { id: 20, name: "Universidad", municipality: "San Nicolás de los Garza", address: "HEB Universidad, Av. Universidad No. 1001, Local 15, Col. Anáhuac", phone: "8352-3201", hasAutoTamal: false, lat: 25.7485, lng: -100.3015 },

  // Juárez
  { id: 21, name: "Matriz", municipality: "Juárez", address: "Arturo B. de la Garza #104 Pte., Cd. B. Juárez", phone: "8233-0406", hasAutoTamal: true, lat: 25.6472, lng: -100.0934 },
  { id: 22, name: "Villa Juárez", municipality: "Juárez", address: "Arturo B. de la Garza #108 Ote., Cd. B. Juárez", phone: "8233-3911", hasAutoTamal: true, lat: 25.6465, lng: -100.0910 },

  // San Pedro Garza García
  { id: 23, name: "Valle", municipality: "San Pedro Garza García", address: "Vasconcelos 920 esq. Matamoros", phone: "8338-6323", hasAutoTamal: false, lat: 25.6596, lng: -100.3952 },

  // Santa Catarina
  { id: 24, name: "HEB Santa Catarina", municipality: "Santa Catarina", address: "Blvd. Díaz Ordaz No.108, L- 24-I", phone: "1477-2424", hasAutoTamal: false, lat: 25.6738, lng: -100.4578 },

  // Apodaca
  { id: 25, name: "Apodaca", municipality: "Apodaca", address: "Mezquital Sta. Rosa / Av. Concordia No.5000, Local 48, Mol Concordia, Col. Hda. Santa Rosa", phone: "8148-6875", hasAutoTamal: false, lat: 25.7801, lng: -100.2312 }
];

const MapComponent = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // Replace with your actual Google Maps API Key
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [map, setMap] = React.useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  const onLoad = React.useCallback(function callback(map) {
    // You could adjust bounds here if needed
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  if (!isLoaded)
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "400px",
          bgcolor: "#f0f0f0",
        }}
      >
        Cargando mapa...
      </Box>
    );

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={11}
      onLoad={onLoad}
      onUnmount={onUnmount}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      }}
    >
      <style>{globalMapStyles}</style>
      
      {salinasStores.map((store) => (
        <Marker
          key={store.id}
          position={{ lat: store.lat, lng: store.lng }}
          onClick={() => setSelectedStore(store)}
          icon={{
            url: require("../assets/tamales-salinas/logo.png"), // Reusing logo as a pin for now until exact pin image is uploaded
            scaledSize: new window.google.maps.Size(36, 36),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(18, 18),
          }}
        />
      ))}

      {selectedStore && (
        <InfoWindow
          position={{ lat: selectedStore.lat, lng: selectedStore.lng }}
          onCloseClick={() => setSelectedStore(null)}
          options={{
            pixelOffset: new window.google.maps.Size(0, -20)
          }}
        >
          <Box sx={{ 
            minWidth: "200px", 
            maxWidth: "250px", 
            overflow: "hidden", 
            borderRadius: "8px" 
          }}>
            {/* Header Image */}
            <Box
              sx={{
                width: "100%",
                height: "80px",
                backgroundImage: `url(${bgBlock})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              {/* Overlay to match the store card look */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(185, 28, 28, 0.65)", // Match the darker red overlay of store cards
                  zIndex: 1,
                }}
              />
            </Box>

            {/* Content Container */}
            <Box sx={{ p: 1.5, textAlign: "center", bgcolor: "white" }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5, color: "#1a1a1a" }}>
                {selectedStore.name} ({selectedStore.municipality})
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mb: 0.5, fontSize: "0.8rem", lineHeight: 1.2 }}>
                {selectedStore.address}
              </Typography>
              {selectedStore.hasAutoTamal && (
                <Typography variant="body2" sx={{ color: "#e31837", mb: 1.5, fontSize: "0.75rem", fontWeight: "bold" }}>
                  ¡Cuenta con Autotamal!
                </Typography>
              )}
              <Button 
                variant="contained" 
                size="medium" // Made larger
                fullWidth
                sx={{ 
                  backgroundColor: "#ffffff", // White background
                  color: "#dc2626", // Red text
                  fontWeight: "bold",
                  fontSize: "1rem", // Larger text
                  py: 1, // More vertical padding
                  borderRadius: "24px", // Increased radius slightly to match size
                  textTransform: "none",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)", // Slightly softer shadow for the white card background
                  "&:hover": {
                    backgroundColor: "#f3f4f6", // Very light gray on hover
                  },
                  mt: selectedStore.hasAutoTamal ? 0 : 1
                }}
                onClick={() => {
                  window.location.href = "https://pide.mennu.mx/salinasjuarez";
                }}
              >
                Ir a tienda
              </Button>
            </Box>
          </Box>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default React.memo(MapComponent);
